import { render, staticRenderFns } from "./BaseSet.vue?vue&type=template&id=2fec51ec&scoped=true"
import script from "./BaseSet.vue?vue&type=script&lang=ts"
export * from "./BaseSet.vue?vue&type=script&lang=ts"
import style0 from "./BaseSet.vue?vue&type=style&index=0&id=2fec51ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec51ec",
  null
  
)

export default component.exports